import React, { useEffect, useState } from "react";
import { Row, Col, Alert, Form, Button, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from 'axios';
import { Coinbase_Auth_Token } from "../../const/const";
import { useAuth } from '../../contexts/auth-context';
import './styles/AdminDashboard.css';
import { metamaskSendUSDC, checkMetaMaskAndNetwork } from '../../helpers';

// GK 2026-04-23 - creates the AdminDashboard page. 
// This is the "homepage" for various admin actions you may wish to take
const AdminDashboard = (props) => {
  const navigate = useNavigate();

  return (
    <div className="text-white">
        <Row className="dashboard-main">
            <Col className="dashboard-item" xs={{span: 24}} md={{span: 8 }}>
                <Button 
                  className="dashboard-btn"
                  type="primary"
                  onClick={() => navigate('/admin/fees')} 
                >
                    Fees
                </Button>
                <Button 
                  className="dashboard-btn" 
                  type="primary" 
                  onClick={() => navigate('/admin/referrers')}
                >
                    Referrers
                </Button>
                <Button 
                  className="dashboard-btn" 
                  type="primary"
                  onClick={() => navigate('/admin/special-payments')}
                >
                    Special Payments
                </Button>
                <Button 
                  className="dashboard-btn" 
                  type="primary"
                  onClick={() => navigate('/admin/maintenance')}
                >
                    Maintenance
                </Button>
            </Col>
        </Row>
    </div>
  );
};

export default AdminDashboard;
